import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { TasksIcon } from '../ui/icons/tasksIcon';
import { TASKS_PATH, tasksRouteRef } from './routeRef';

/**
 * The « Tâches » page (TasksPage.tsx), for everyone. A title and an icon so
 * that the app's nav lists it; the sidebar takes it explicitly, right after
 * « Créer », and draws it with its badge (`TasksNavItem`, taken as
 * `page:waadoo-tasks` in modules/nav/Sidebar.tsx). The title is French as
 * it stands, like the home page's.
 *
 * `noHeader`: the page paints its own header, with its description.
 */
const tasksPage = PageBlueprint.make({
  params: {
    path: TASKS_PATH,
    title: 'Tâches',
    icon: <TasksIcon />,
    routeRef: tasksRouteRef,
    noHeader: true,
    loader: async () => {
      const { TasksPage } = await import('./TasksPage');
      return <TasksPage />;
    },
  },
});

/** Registered in packages/app/src/App.tsx. */
export const tasksPlugin = createFrontendPlugin({
  pluginId: 'waadoo-tasks',
  extensions: [tasksPage],
});

export default tasksPlugin;
